<template>
  <div>
      <!-- <h3>Manage Onboarding </h3> -->
      <div class="row">
        <EmailVerification />
      </div>
      <div class="row">
        <PhoneVerification />
      </div>
      <div class="row">
        <ReleasePhoneLock />
      </div>
      <div class="row">
        <AccountVerification />
      </div>
      <div class="row">
        <VerificationStatus />
      </div>
  </div>
</template>

<script>
import EmailVerification from "./emailVerification.vue";
import PhoneVerification from "./phoneVerification.vue";
import ReleasePhoneLock from "./releasePhoneLock.vue";
import AccountVerification from "./accountVerification.vue";
import VerificationStatus from "./verificationStatus.vue";


export default {
  components: {
    EmailVerification,
    PhoneVerification,
    ReleasePhoneLock,
    AccountVerification,
    VerificationStatus
  }
}
</script>

<style>

</style>
